






































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import DownloadIcon from 'mdi-vue/Download';
import { mapState } from 'vuex';
import api from '@/libs/api';
import { InvoiceListProfileResponse, User } from '@/libs/api.interfaces';
import FormInput from '@/components/FormInput.vue';
import VueMonthlyPicker from 'vue-monthly-picker';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import hasPermission from '@/libs/permission';
import ProductListTable from './ProductListTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    FormInput,
    Loader,
    Button,
    Tab,
    SearchIcon,
    DownloadIcon,
    VueMonthlyPicker,
    SearchField,
    SearchRow,
    Select,
    ProductListTable,
    AddIcon,
  },
  computed: mapState(['user']),
  methods: {
    hasPermission,
  },
})
export default class ProductList extends Vue {
  user!: {
    user: User;
  };

  searchOpen = false;

  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  merchantId = 0;
  name = '';
  profile: LabelValue | null = null;
  profiles: LabelValue[] = [];
  loadingProfile = true;

  $refs!: {
    report: ProductListTable;
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  mounted() {
    this.merchantId = this.user.user.merchant_id;
    this.getProfiles();
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getProfiles() {
    try {
      this.loadingProfile = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceListProfileResponse>('/easyinvoice/invoices_list_profile', {
        user_group: 0,
        merch_id: this.merchantId,
      });

      this.profiles = data.profile.map((e) => ({ label: e.name, value: e.id }));
      this.loadingProfile = false;
    } catch (err) {
      console.error(err);
    }
  }

  search() {
    this.$router.push({
      query: {
        name: this.name === null ? undefined : this.name,
        profile: this.profile === null ? undefined : JSON.stringify(this.profile),
      },
    });
  }

  reset() {
    this.name = '';
    this.profile = null;

    this.$router.push({
      query: {},
    });
  }

  parseParams() {
    // const today = new Date();
    // const lastweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    const params = this.$route.query;
    // console.log(this.$route.query);
    if (typeof params.name === 'string') {
      const name = params.name.toString();
      if (name) {
        this.name = name;
      } else {
        this.name = '';
      }
    }

    if (typeof params.profile === 'string') {
      const profile = params.profile.toString();
      if (profile) {
        this.profile = JSON.parse(profile);
      } else {
        this.profile = null;
      }
    }
    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getProducts(page);
  }

  async getProducts(page: number) {
    const params = {
      name: this.name,
      profile: this.profile,
    };
    await this.$refs.report.getProducts(params, page);
  }
}
